<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="550px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t(`Edit Dividend's Information`) }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 pa-2 ma-2 white>
              Income After Tax: <strong>{{ income.income_after_tax | currency }}</strong>
            </v-flex>
            <v-flex xs12 pa-2 ma-2 white>
              Total Share Number: <strong>{{ income.total_share_number | currency }}</strong>
            </v-flex>
            <v-flex xs12 pa-2 ma-2 white>
              Share Profit Amount: <strong>{{ income.share_profit_amount | currency }}</strong>
            </v-flex>

            <v-flex xs12 pa-2>
              <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="viewInfo.dividend_date"
                  :label="`${$t('Dividend Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="dividend_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('dividend_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="dateMenu = false" v-model="viewInfo.dividend_date" />
              </v-menu>
            </v-flex>

            <v-flex xs12 pa-2>
              <v-text-field
                v-model.number="viewInfo.share_profit_amount"
                :label="`${$t('Share Profit Amount')} *`"
                name="share_profit_amount"
                box
                readonly
                hide-details
                background-color="white"
                :error="errors.has('share_profit_amount')"
                v-validate="'required|decimal'"
              />
            </v-flex>

            <v-flex xs12 pa-2>
              <v-text-field
                v-model.number="viewInfo.total_dividend_amount"
                :label="`${$t('Dividend Amount')} *`"
                name="total_dividend_amount"
                box
                hide-details
                background-color="white"
                :error="errors.has('total_dividend_amount')"
                v-validate="'required|decimal:3|min_value:0|max_value:' + income.income_after_tax"
                data-vv-delay="1000"
                @input="calculateShareProfitAmount()"
              />
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      dateMenu: false,
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'dividends/getDividendInfo',
      income: 'dividends/getIncomeAfterTax'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateDividendInfo: 'dividends/updateDividendInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    calculateShareProfitAmount() {
      this.viewInfo.share_profit_amount = Number(
        this.viewInfo.total_dividend_amount / this.income.total_share_number
      ).toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.viewInfo.dividend_id, formData }

          this.updateDividendInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped></style>
